import { useEffect, useState, useMemo } from 'react';

// API
import conObj from '../../utils/connection-assistant';

export default function usePopularLoadOnScroll() {
  const [page, setPage] = useState(0);

  const [popularGames, setPopularGames] = useState([]);

  const [popularGamesTotal, setPopularGamesTotal] = useState(0);

  const [isLoadingPopGames, setIsLoadingPopGames] = useState(false);

  const hasMore = useMemo(() => {
    if (popularGames?.length >= 300) return false;
    return true;
  }, [popularGamesTotal, popularGames]);

  useEffect(() => {
    setIsLoadingPopGames(true);
    conObj
      .post(`/games/items.json?sort=popularity&limit=${20}&page=${page}`)
      .then((res) => {
        if (res.status === 200) {
          setPopularGames((prevState) => [...prevState, ...res.data?.data?.data]);
          setPopularGamesTotal(res.data?.data?.page?.total_data);
          setIsLoadingPopGames(false);
        }
      })
      .catch((err) => {
        setIsLoadingPopGames(false);
        console.log(`Error: ${err.message}`);
      });
  }, []);

  return {
    popularGames,
    isLoadingPopGames,
    hasMore,
    setPage,
  };
}
